const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString();

export const itemActions = [
  { id: "a1", itemId: "c1", type: "tarea", title: "Montar el flujo n8n de facturas", done: false, createdAt: daysAgo(1) },
  { id: "a2", itemId: "e8", type: "tarea", title: "Probar pgvector con datos reales", done: false, createdAt: daysAgo(2) },
  { id: "a3", itemId: "c4", type: "tarea", title: "Revisar el checklist antes del deploy", done: true, createdAt: daysAgo(6) },
  { id: "a4", itemId: "c1", type: "nota", title: "Nodos clave del flujo de facturas", createdAt: daysAgo(1) },
  { id: "a5", itemId: "c6", type: "nota", title: "Patrones de copy para el hero", createdAt: daysAgo(1) },
  { id: "a6", itemId: "c5", type: "idea", title: "Resúmenes semanales de podcasts", createdAt: daysAgo(4) },
  { id: "a7", itemId: "c2", type: "idea", title: "Modo oscuro cálido para el dashboard", createdAt: daysAgo(3) },
];
